export * from './footer/footer.component';
export * from './header/header.component';
export * from './normal-layout/normal-layout.component';
